export default __webpack_public_path__ + "4e76adf32fc2428450225eec38c15c05.svg";